import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function HotelResults() {
  const nav = useNavigate();
  const loc = useLocation() as any;
  const offers = loc?.state?.offers || [];
  const search = loc?.state?.search || {};
  const tenor = 12;

  if (!offers.length) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center p-6">
          <h2 className="text-xl font-semibold text-foreground mb-2">No Hotels Found</h2>
          <p className="text-muted-foreground mb-4">Go back and search again.</p>
          <button 
            onClick={() => nav(-1)}
            className="px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 smooth-transition"
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-5xl mx-auto p-6">
        <h2 className="text-xl font-heading font-semibold mb-4 text-flexaura-navy">
          Hotels in {search.destination}
        </h2>
        
        <div className="text-sm text-muted-foreground mb-6">
          {search.checkIn} - {search.checkOut} • {search.rooms} room(s) • {search.adults} adult(s)
        </div>

        <div className="grid gap-4">
          {offers.map((offer: any) => {
            const total = Number(offer?.total_amount) || Number(offer?.total || 0);
            const monthly = Math.ceil(total / tenor);
            const hotel = offer?.accommodation || offer?.hotel || {};
            const room = offer?.room_rate || offer?.rate || {};
            
            return (
              <div 
                key={offer.id} 
                className="border border-border rounded-2xl p-5 card-shadow bg-card smooth-transition hover:elevated-shadow"
              >
                <div className="flex flex-col md:flex-row md:justify-between gap-4">
                  <div className="flex-1">
                    <div className="text-lg font-medium text-flexaura-navy mb-1">
                      {hotel?.name || "Hotel Name Not Available"}
                    </div>
                    <div className="text-sm text-muted-foreground mb-2">
                      {hotel?.location?.city || hotel?.address || "Location not specified"}
                    </div>
                    
                    {room?.room_type && (
                      <div className="text-sm text-foreground mb-2">
                        Room: {room.room_type}
                      </div>
                    )}
                    
                    {hotel?.amenities && (
                      <div className="text-sm text-muted-foreground">
                        Amenities: {hotel.amenities.slice(0, 3).join(", ")}
                        {hotel.amenities.length > 3 && "..."}
                      </div>
                    )}
                    
                    <div className="text-lg font-semibold text-flexaura-navy mt-3">
                      AED {total.toLocaleString()}
                      <span className="text-sm font-normal text-muted-foreground ml-2">
                        per stay
                      </span>
                    </div>
                  </div>
                  
                  <div className="flex flex-col items-end gap-3 md:min-w-[200px]">
                    <span className="text-sm px-3 py-1 rounded-full text-white gradient-bg">
                      From AED {monthly}/mo
                    </span>
                    
                    <button
                      onClick={() => nav("/stays/checkout", { state: { offer, tenor } })}
                      className="px-6 py-2 rounded-2xl text-white font-medium bg-flexaura-navy hover:bg-flexaura-navy/90 smooth-transition"
                    >
                      Select
                    </button>
                  </div>
                </div>
                
                {(room?.cancellation_policy || room?.meal_plan) && (
                  <div className="mt-4 pt-4 border-t border-border">
                    <div className="flex flex-wrap gap-4 text-sm text-muted-foreground">
                      {room?.cancellation_policy && (
                        <span>
                          {room.cancellation_policy === 'free_cancellation' 
                            ? '✅ Free Cancellation'
                            : '❌ Non-refundable'
                          }
                        </span>
                      )}
                      {room?.meal_plan && (
                        <span>🍽️ {room.meal_plan}</span>
                      )}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}